
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.778 8.26L5.11 4.349h9.778l1.333 3.913m-1.333 4.348c-.354 0-.693-.138-.943-.382a1.29 1.29 0 01-.39-.923c0-.346.14-.677.39-.922s.59-.382.943-.382c.354 0 .693.137.943.382s.39.576.39.922c0 .346-.14.678-.39.923-.25.244-.59.382-.943.382zm-9.778 0c-.354 0-.693-.138-.943-.382a1.29 1.29 0 01-.39-.923c0-.346.14-.677.39-.922s.59-.382.943-.382c.354 0 .693.137.943.382s.39.576.39.922c0 .346-.14.678-.39.923-.25.244-.59.382-.943.382zm11.04-8.696a1.33 1.33 0 00-1.262-.87H5.11a1.33 1.33 0 00-1.262.87L2 9.13v6.957c0 .23.094.452.26.615a.899.899 0 00.629.254h.889a.899.899 0 00.628-.254.86.86 0 00.26-.615v-.87h10.667v.87c0 .23.094.452.26.615a.899.899 0 00.63.254h.888a.899.899 0 00.629-.254.86.86 0 00.26-.615V9.13l-1.849-5.217z","fill":"#94A3B8"}})])
          )
        }
      }
    